/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { LicenseClass, Vehicle } from '@shared/models';

export interface VehiclesState {
  vehicles: Vehicle[];
  currentVehicle?: Vehicle;
  isActionPending: boolean;
  licenseClasses: LicenseClass[];
}

export const initialState: VehiclesState = {
  vehicles: [],
  isActionPending: false,
  licenseClasses: []
};
